import { render, staticRenderFns } from "./CustomAttributeTypeSelection.vue?vue&type=template&id=6a41ddbc"
import script from "./CustomAttributeTypeSelection.vue?vue&type=script&lang=ts"
export * from "./CustomAttributeTypeSelection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports